import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Grid, Tooltip } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tooltipLabel: {
    display: "inline",
    fontSize: "0.75em",
    padding: `${theme.spacing(0.125)}px ${theme.spacing(0.5)}px`,
    background: theme.palette.statusIcons.failed,
    borderRadius: theme.spacing(0.5),
  },
  tooltip: {
    marginTop: theme.spacing(0.75),
    fontSize: "0.75em",
    background: theme.palette.statusIcons.failed,
  },
}));

export const FailedBrainTreeTransactionRenderer = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { t } = useTranslation();

  return (
    <Grid>
      <Typography className={classes.tooltipLabel}>
        {t("Riders.WalletTransactions.Failed")}
      </Typography>
    </Grid>
  );
};

export const TransactionRowRenderer = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { t } = useTranslation();
  const { transaction } = props;

  return (
    <Grid>
      <Tooltip
        classes={{ tooltip: classes.tooltip }}
        title={transaction.error?.message || t("Riders.WalletTransactions.NoErrorDetails")}
        placement="bottom-start"
      >
        <Typography className={classes.tooltipLabel}>
          {transaction.status === "failed" || transaction.status === "canceled"
            ? t("Riders.WalletTransactions.Failed")
            : t("Riders.WalletTransactions.Abandoned")}
        </Typography>
      </Tooltip>
    </Grid>
  );
};

TransactionRowRenderer.propTypes = {
  transaction: PropTypes.object.isRequired,
};
